import React, { useState, useEffect, useContext } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from "react-router-dom";
import { getOfertas } from '../../actions/home';
import { getSliders } from '../../actions/home';
import { CartContext } from '../../contexts/CartContext';
import Swal from 'sweetalert2';
import { formatPrice } from '../../utils/formatPrice';

export const Offers = ({ showButton = false }) => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sliders, setSliders] = useState([])
  const { addToCart } = useContext(CartContext);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5, // Número de elementos visibles por slide
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1.5,
        },
      },
      {
        breakpoint: 393,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
    ],
  };

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const result = await getOfertas();
        setProductos(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  useEffect(() => {
    const loadSliders = async () => {
      try {
        const result = await getSliders();
        setSliders(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadSliders();
  }, [])

  const addCarrito = (producto) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Se agregó al carrito de compras",
      showConfirmButton: false,
      timer: 2500,
      customClass: {
        container: 'custom-body'
      }
    });

    const productoCantidad = {
      ...producto,
      cantidad: 1,
    };
    console.log('agregar', productoCantidad);
    addToCart(productoCantidad);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className=''>
      <Slider {...settings} className='mrg-product-offers container-product-offer'>
        {
          productos.map(c => {
            const descuentoPorcentaje = Math.floor(parseFloat(c.productoDescuentoPorcentaje));

            return (
              <div key={c.productoId} className='card-wrapper-2'>
                <div className='card-2'>
                  <div className='font-family-montserrat txt-300 font14 btn-ahorro pbuttonoffers width-offers'>
                    Ahorras {descuentoPorcentaje}%
                  </div>
                  <Link to={`/detalle-producto/${c.productoSku}`} className='flex-container flex-center'>
                    <img
                      src={process.env.REACT_APP_URL_MINIO+c.productoImgUrlPrincipal}
                      alt={c.productoNombre}
                      className='img-responsive img-responsive-v3' />
                  </Link>
                  <div className=' container-100'>
                    <div className='container-100 flex-container flex-column pd-txt-offers container-box-offers'>
                      <div className=' pd-top-offer container-100'>
                        <div className='font-description font-offers txt-descrip-offers font-family-montserrat font400'>
                          {c.productoNombre}
                        </div>
                        {/* <div className='font-family-montserrat btn-cart pointer margin-top-30'>Añadir al carrito</div> */}
                      </div>
                      <div className='mrg-topauto-offers'>
                        <div className='flex-container precio-offers font-family-montserrat font400 pd-precios precio-offer baseline-items container-100'>
                          <div className='font400 precio-moresale precio-offers'>
                            {/* {c.productoPrecio !== null ? `S/ ${c.productoPrecio}` : 'Precio no disponible'} */}
                            {formatPrice(c.productoPrecio)}
                          </div>
                          {c.productoPrecioAnterior && (
                            <div className='tachado flex-center precio-tachado tachado-offers'>
                              {/* {`S/ ${c.productoPrecioAnterior}`} */}
                              {formatPrice(c.productoPrecioAnterior)}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {showButton && (
                      <div className='container-btn-moreSale container-btn-offers'>
                        <div
                          className='font-family-montserrat btn-cart btn-cart-offer pointer font14'
                          onClick={() => addCarrito(c)}>
                          Añadir al carrito
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        }

      </Slider>
    </div>
  )
}
